// src/pages/sales-order/components/SectionGrid.jsx
import React from "react";
import FieldRenderer from "./FieldRenderer";

/** Grid renderer for a section */
export default function SectionGrid({
    fields,
    formData,
    errors,
    onChange,
    readOnly = false,
    idPrefix = "sec",
    getInputTypeForField,
    getValueForField,
    colClass = "col-12 col-sm-6 col-md-2",
}) {
    return (
        <div className="row g-3 mx-0">
            {fields.map((field) => (
                <div key={field.name} className={colClass}>
                    <FieldRenderer
                        field={field}
                        value={formData[field.name]}
                        onChange={onChange}
                        error={errors?.[field.name]}
                        readOnly={readOnly}
                        idPrefix={`${idPrefix}-${field.name}`}
                        getInputTypeForField={getInputTypeForField}
                        getValueForField={getValueForField}
                    />
                </div>
            ))}
        </div>
    );
}
